import { ABBY_BASE_URL } from './chunk-2HPJHXZH.mjs';
import { __async, __spreadValues } from './chunk-XEH7ODH4.mjs';

// src/shared/http.ts
var HttpService = class {
  static getProjectData(_0) {
    return __async(this, arguments, function* ({
      projectId,
      environment,
      url,
      fetch: fetch2 = globalThis.fetch,
      __experimentalCdnUrl
    }) {
      try {
        const res = yield fetch2(
          __experimentalCdnUrl != null ? __experimentalCdnUrl : `${url != null ? url : ABBY_BASE_URL}api/v1/data/${projectId}${environment ? `?environment=${environment}` : ""}`
        );
        if (!res.ok)
          return null;
        const data = yield res.json();
        return data;
      } catch (err) {
        console.error("[ABBY]: failed to load project data, falling back to defaults");
        return null;
      }
    });
  }
  static sendData({
    url,
    type,
    data
  }) {
    if (typeof window === "undefined" || window.location.hostname === "localhost") {
      return;
    }
    return fetch(`${url != null ? url : ABBY_BASE_URL}api/data`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(__spreadValues({ type }, data))
      // catch error and forget about them for now
      // TODO: add error debugging
    }).catch(() => {
    });
  }
};

export { HttpService };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-YETZGIZF.mjs.map